
import { BUDGET_DISPATCHER } from "../SchemaTypes";
import { useParsedFieldProps } from "./useParsedFieldProps";
import BudgetDispatcherInput from "../../Input/BudgetDispatcherInput";
import Field, { FIELD_MODE_FIELDSET } from "../Field";

const BudgetDispatcherField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent, budget, maxBudgetPerOption, minBudgetToSpend } = props;

  const schema = {
    type: BUDGET_DISPATCHER,
    parent,
    validations: {
      required: required,
      budgetSpent: {
        budget,
        maxBudgetPerOption,
        minBudgetToSpend
      }
    }
  };

  return (
    <Field {...fieldProps} schema={schema} fieldMode={FIELD_MODE_FIELDSET}>
      <BudgetDispatcherInput {...inputProps} />
    </Field>
  );
};

export default BudgetDispatcherField;
